// extracted by mini-css-extract-plugin
export default {"CommentsButton":"il_a bhy_wx bhy_jb bhy_xl bhy_i bhy_j bhy_q bhy_vt bhy_et bhy_so bhy_sp bhy_eg","CommentsButton__icon":"il_b bhy_rz"};